/* unplugin-vue-components disabled */import script from "./VerificationCode.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerificationCode.vue?vue&type=script&setup=true&lang=ts"

import "./VerificationCode.vue?vue&type=style&index=0&id=616e8d76&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/quantum-technology/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-616e8d76"]])

export default __exports__